import React from "react"

import MDBox from "materialDashboard/components/MDBox";
import MDTypography from "materialDashboard/components/MDTypography";
import WorkgroupAvatar from "./WorkgroupAvatar";


const WorkgroupCol = ({workgroup}) => {
    if (!workgroup) {
        return null;
    }
    const {name} = workgroup;

    return <MDBox display="flex" alignItems="center" lineHeight={1}>
        <WorkgroupAvatar workgroup={workgroup} />
        <MDTypography display="block" variant="button" fontWeight="medium" ml={2}>
            {name}
        </MDTypography>
    </MDBox>;
}

export default WorkgroupCol;